import getApiUrl from "../../helpers/getApiUrl";
import getEnvironment from "../../helpers/getEnvironment";

const acceptTermsAndConditions = async (
  url: string,
  method: "put" | "get",
  isToUseAuthZero: boolean = false,
  accessToken?: string
) => {
  const isLocalhost = !["preview", "production"].includes(getEnvironment());
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else if (!isToUseAuthZero && isLocalhost && process.env.token) {
    headers.Authorization = `Bearer ${process.env.token}`;
  }

  const res = await fetch(getApiUrl(url, isToUseAuthZero), {
    method: method,
    headers,
  });

  if (res.status > 200) {
    return `${res.status} Could not accept T&C`;
  }
  const response = await res.json();
  return response;
};

export default acceptTermsAndConditions;
